<script setup lang="ts">
import ApplicationBase from '../ApplicationBase.vue'
import { useJoakimStore } from '@/stores/useJoakimStore'

// Steps
import ApplicationEllilifeyriBegin from './Steps/ApplicationEllilifeyriBegin.vue'
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import PEP from '../Shared/PEP.vue'
import Step6 from './Steps/Step6.vue'
import Undirritun from '../Shared/Undirritun.vue'

// Constants for this application
const TYPE_ID = 0
const UPDATE_KEY = 'lifeyrisumsokn'

const joakim = useJoakimStore()

async function runBankCheck(umsokn: any) {
  const res = await joakim.checkBankaReikning(umsokn)
  const data = (res as any)?.data ?? res
  const valid = !!data?.valid
  return { valid, errorMessage: valid ? '' : (data?.message || 'Ógildur bankareikningur') }
}

// Define step flow (including Begin step at index 0)
const steps = [
  { comp: ApplicationEllilifeyriBegin, titleKey: '' },
  { comp: Umsaekjandi,                 titleKey: 'lifeyrir_umsokn_step1_header1' },
  { comp: Step2,                       titleKey: 'lifeyrir_umsokn_step2_header1', props: { runBankCheck } },
  { comp: Step3,                       titleKey: 'lifeyri_umsokn_step3_header1' },
  { comp: Step4,                       titleKey: 'lifeyri_umsokn_step4_header1' },
  { comp: Step5,                       titleKey: 'lifeyri_umsokn_step5_header1' },
  { comp: PEP,                         titleKey: 'umsokn_PEP_header' },
  { comp: Step6,                       titleKey: 'lifeyri_umsokn_step6_header1' },
  { comp: Undirritun,                  titleKey: 'undirritun_umsokn_header1' }
]
</script>

<template>
  <ApplicationBase
    :app-id="TYPE_ID"
    :update-key="UPDATE_KEY"
    :steps="steps"
  />
</template>
